import clsx from "clsx";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { GetFileObjectById, resetGetFileObjectByIdStatus } from "../../../../objectStorage/slice";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import CheckboxGroup from "../../../../ui/molecules/CheckBoxGroup";
import InputMultiSearch from "../../../../ui/molecules/input/InputMultiSearch";
import { MadfarmInput } from "../../../../ui/molecules/input/newInput";
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import TextArea from "../../../../ui/molecules/textArea";
import { PopupForm } from "../../../../ui/organisms/popupForm";
import { DeliveryManagementType, OptionType, countries, departureMeansOptions, regioniList } from "../../../../utils";
import { FindMe, resetfindMeStatusIdle } from "../../../users/slice";
import { AddObjectPopupEntry } from "../../popup/addObjectEntry";
import { DepartureProtocolCreation, DepartureProtocolUpdate, DepartureProtocolUploadAttachmentFile, GetAllDepartureProtocolObjects, GetDepartureProtocolById, resetDepartureProtocolErrors, resetDepartureProtocolUpdateStatus, resetDepartureProtocolUploadAttachmentFileStatus, resetDepartureProtocolValidationStatus, resetGetAllDepartureProtocolObjectsStatus, setCorriere, setDataBolgetta, setDataReceive, setDataRicezioneCompiutaGiacenza, setDataRitornoErratoIndirizzo, setDepartureProtocolIdToUpdate, setFileToUpdate, setFromCreationToUpdate, setNumRaccomandata, setNumeroRaccomandataErratoIndirizzo, setPEC, setPPCustomerIds, setPPCustomersNotRegistered, setPPDepartureChannel, setPPDepartureObjectId, setPPFileAndAtt, setPPHeadquarter, setPPLinkExistingProtocol, setPPNation, setPPObjectSpec, setPPReceiver, setPPRegion, setPPTotalPage, setPPUserId, setPProtocolDate, setPostaElettronica, setRaccomandataAr, setRaccomandataMano, setUpdateCorriere, setUpdateDataBolgetta, setUpdateDataReceive, setUpdateDataRicezioneCompiutaGiacenza, setUpdateDataRitornoErratoIndirizzo, setUpdateNumRaccomandata, setUpdateNumeroRaccomandataErratoIndirizzo, setUpdatePEC, setUpdatePPCustomerIds, setUpdatePPCustomersNotRegistered, setUpdatePPDepartureAttachmentIds, setUpdatePPDepartureChannel, setUpdatePPDepartureObjectId, setUpdatePPHeadquarter, setUpdatePPLinkExistingProtocol, setUpdatePPNation, setUpdatePPObjectSpec, setUpdatePPProtocolDate, setUpdatePPRegion, setUpdatePPSend, setUpdatePPTotalPage, setUpdatePPUsersVisibility, setUpdatePostaElettronica, setUpdateRaccomandataAr, setUpdateRaccomandataMano, setUpdatedFile, setUpdatedPPAttachmentFile, setUpdatepPSender } from "../slice";

export function NewDepartureLeft() {
    const dispatch = useAppDispatch()
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const userState = useAppSelector(state => state.users)
    const [selectedDeliveries, setSelectedDeliveries] = useState<DeliveryManagementType[]>([])
    const departureProtocolState = useAppSelector(state => state.departureProtocol)
    const objectStorageState = useAppSelector(state => state.objectStorage)
    const [objects, setObjects] = useState<OptionType[]>([])
    const [file, setFile] = useState<File | null>(null)
    const [officeSot, setOfficeSot] = useState<OptionType[]>([])

    let formData = new FormData();
    let attachmentFormdata = new FormData();

    useEffect(() => {
        dispatch(FindMe())
    }, [])

    useEffect(() => {
        if (userState.findMeStatus === 'successfully') {
            dispatch(resetfindMeStatusIdle())
            if (userState.findMeResponse.headQuarterInfo !== null && userState.findMeResponse.headQuarterInfo !== undefined) {
                const newOption: OptionType = {
                    value: userState.findMeResponse.headQuarterInfo.code,
                    label: userState.findMeResponse.headQuarterInfo.code
                };

                setOfficeSot(prevOptions => {
                    const optionExists = prevOptions.some(option => option.value === newOption.value);
                    if (!optionExists) {
                        return [...prevOptions, newOption];
                    }
                    return prevOptions;
                });
            }

            if (userState.findMeResponse.office !== null && userState.findMeResponse.office !== undefined) {
                const newOption: OptionType = {
                    value: userState.findMeResponse.office,
                    label: userState.findMeResponse.office
                };

                setOfficeSot(prevOptions => {
                    const optionExists = prevOptions.some(option => option.value === newOption.value);
                    if (!optionExists) {
                        return [...prevOptions, newOption];
                    }
                    return prevOptions;
                });
            }
        }
    }, [userState.findMeStatus])

    useEffect(() => {
        if (departureProtocolState.getAllDepartureProtocolObjectsStatus === 'successfully' &&
            departureProtocolState.getAllDepartureProtocolObjectsResponse !== undefined
        ) {
            dispatch(resetGetAllDepartureProtocolObjectsStatus())
            const data = departureProtocolState.getAllDepartureProtocolObjectsResponse
            const newObjects: OptionType[] = data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setObjects(newObjects)
        }
    }, [departureProtocolState.getAllDepartureProtocolObjectsStatus])

    useEffect(() => {
        setFile(departureProtocolState.fileToUpdate as File)
    }, [departureProtocolState.fileToUpdate])

    useEffect(() => {

        if (departureProtocolState.departureProtocolValidationStatus === 'successfully') {
            dispatch(resetDepartureProtocolValidationStatus())
            if (!departureProtocolState.fromCreationToUpdate) {
                dispatch(DepartureProtocolCreation(departureProtocolState.departureProtocolCreationRequest))
            }
            else {
                formData.delete('file')
                if (file !== null && file !== undefined)
                    formData.append('file', file)
                formData.append('departureProtocolUpdateDTO', JSON.stringify(departureProtocolState.departureProtocolUpdateRequest))
                dispatch(DepartureProtocolUpdate({ body: formData, id: departureProtocolState.departureProtocolIdToUpdate }))
            }
        }
    }, [departureProtocolState.departureProtocolValidationStatus])

    useEffect(() => {
        if (departureProtocolState.getDepartureProtocolByIdStatus === 'successfully' &&
            departureProtocolState.getDepartureProtocolByIdResponse !== undefined
        ) {
            dispatch(setFromCreationToUpdate(true))
            const data = departureProtocolState.getDepartureProtocolByIdResponse
            dispatch(setUpdatePPProtocolDate(data.protocolDate))
            dispatch(setDepartureProtocolIdToUpdate(data.id))
            dispatch(setUpdatePPHeadquarter(data.headQuarter))
            dispatch(setUpdatePPNation(data.nation))
            dispatch(setUpdatePPRegion(data.region))
            dispatch(setUpdatepPSender(data.receiver))
            if (data.customersInfo !== null)
                dispatch(setUpdatePPCustomerIds(data.customersInfo.map(c => c.id)))
            dispatch(setUpdatePPCustomersNotRegistered(data.customersNotRegistered))
            dispatch(setUpdatePPDepartureObjectId(data.departureObject.id))
            dispatch(setUpdatePPObjectSpec(data.objectSpec))
            dispatch(setUpdatePPTotalPage(data.totalPage))
            dispatch(setUpdatePPDepartureChannel(data.departureChannel))
            dispatch(setUpdatePPSend(data.send))
            dispatch(setUpdatePPUsersVisibility(data.usersVisibility))
            dispatch(setUpdatePPLinkExistingProtocol(data.linkExistingProtocol))
            dispatch(setUpdatePPDepartureAttachmentIds(data.departureAttachments.map(att => att.id)))
            dispatch(setUpdateNumRaccomandata(data.numeroRaccomandata))
            dispatch(setUpdateDataBolgetta(data.dataBolgetta))
            dispatch(setUpdateDataRicezioneCompiutaGiacenza(data.dataRicezioneCompiutaGiacenza))
            dispatch(setUpdateDataRitornoErratoIndirizzo(data.dataRitornoErratoIndirizzo))
            dispatch(setUpdateNumeroRaccomandataErratoIndirizzo(data.numeroRaccomandataErratoIndirizzo))
            dispatch(setUpdateCorriere(data.corriere))
            dispatch(setUpdateRaccomandataMano(data.raccomandataMano))
            dispatch(setUpdatePostaElettronica(data.postaElettronica))
            dispatch(setUpdateDataReceive(data.receive))
            dispatch(setUpdateRaccomandataAr(data.raccomandataAr))
            dispatch(setUpdatePEC(data.postaElettronicaCertificata))
            dispatch(setUpdatedPPAttachmentFile(data.attachmentFile))
        }
    }, [departureProtocolState.getDepartureProtocolByIdStatus])

    useEffect(() => {
        setFile(null)
        dispatch(setPPUserId(userState.loggedUserId))
        dispatch(setFromCreationToUpdate(false))
        dispatch(resetDepartureProtocolErrors())
        dispatch(GetAllDepartureProtocolObjects())
    }, [])

    useEffect(() => {
        if (departureProtocolState.departureProtocolUpdateStatus === 'successfully' &&
            departureProtocolState.departureProtocolUpdateResponse !== undefined
        ) {
            dispatch(resetDepartureProtocolUpdateStatus())
            dispatch(setFileToUpdate(null))
            if (departureProtocolState.departureProtocolUpdateResponse !== null)
                dispatch(GetFileObjectById(departureProtocolState.departureProtocolUpdateResponse))

            if (departureProtocolState.departureProtocolUpdateFileAndAtt.length > 0) {
                const attF = departureProtocolState.departureProtocolUpdateFileAndAtt[0]
                dispatch(setPPFileAndAtt(departureProtocolState.departureProtocolUpdateFileAndAtt.slice(1)))
                if (attF !== undefined && attF && attF !== null) {
                    if (attF.file !== undefined && attF.file) {
                        attachmentFormdata.delete('file')
                        attachmentFormdata.append('file', attF.file)
                        attachmentFormdata.append('attachmentFileDTO', JSON.stringify({ attachmentId: attF.attachmentId }))
                        dispatch(DepartureProtocolUploadAttachmentFile({ data: attachmentFormdata, id: departureProtocolState.departureProtocolIdToUpdate }))
                    }
                }
            }
        }
    }, [departureProtocolState.departureProtocolUpdateStatus])

    useEffect(() => {
        if (departureProtocolState.departureProtocolUploadAttachmentFileStatus === 'successfully') {
            dispatch(resetDepartureProtocolUploadAttachmentFileStatus())
            if (departureProtocolState.departureProtocolUpdateFileAndAtt.length > 0) {
                const attF = departureProtocolState.departureProtocolUpdateFileAndAtt[0]
                dispatch(setPPFileAndAtt(departureProtocolState.departureProtocolUpdateFileAndAtt.slice(1)))
                if (attF !== undefined && attF && attF !== null) {
                    if (attF.file !== undefined && attF.file) {
                        attachmentFormdata.delete('file')
                        attachmentFormdata.append('file', attF.file)
                        attachmentFormdata.append('attachmentFileDTO', JSON.stringify({ attachmentId: attF.attachmentId }))
                        dispatch(DepartureProtocolUploadAttachmentFile({ data: attachmentFormdata, id: departureProtocolState.departureProtocolIdToUpdate }))
                    }
                }
            } else {
                dispatch(GetDepartureProtocolById(departureProtocolState.departureProtocolIdToUpdate))
            }
        }
    }, [departureProtocolState.departureProtocolUploadAttachmentFileStatus])

    useEffect(() => {
        if (objectStorageState.getFileObjectByIdStatus === 'successfully' &&
            objectStorageState.getFileObjectByIdResponse !== undefined
        ) {
            dispatch(resetGetFileObjectByIdStatus())
            dispatch(setUpdatedFile(objectStorageState.getFileObjectByIdResponse))
        }
    }, [objectStorageState.getFileObjectByIdStatus])

    const handleTypesChange = (value: DeliveryManagementType) => {
        let currentDeliveries = [...selectedDeliveries]
        if (currentDeliveries.includes(value)) {
            currentDeliveries = currentDeliveries.filter(t => t !== value)
        }
        else {
            currentDeliveries.push(value)
        }
        setSelectedDeliveries(currentDeliveries)

        const corriereState = currentDeliveries.includes(DeliveryManagementType.CORRIERE)
        !departureProtocolState.fromCreationToUpdate ?
            dispatch(setCorriere(corriereState)) :
            dispatch(setUpdateCorriere(corriereState))

        const raccAManoState = currentDeliveries.includes(DeliveryManagementType.RACC_M)
        !departureProtocolState.fromCreationToUpdate ?
            dispatch(setRaccomandataMano(raccAManoState)) :
            dispatch(setUpdateRaccomandataMano(raccAManoState))

        const postaElettState = currentDeliveries.includes(DeliveryManagementType.POST_E)
        !departureProtocolState.fromCreationToUpdate ?
            dispatch(setPostaElettronica(postaElettState)) :
            dispatch(setUpdatePostaElettronica(postaElettState))

        const pecState = currentDeliveries.includes(DeliveryManagementType.PEC)
        !departureProtocolState.fromCreationToUpdate ?
            dispatch(setPEC(pecState)) :
            dispatch(setUpdatePEC(pecState))

        const raccARState = currentDeliveries.includes(DeliveryManagementType.RACC_AR)
        !departureProtocolState.fromCreationToUpdate ?
            dispatch(setRaccomandataAr(raccARState)) :
            dispatch(setUpdateRaccomandataAr(raccARState))
    }

    return (
        <div className="pb-6">
            <div className="protocol-header">
                <span className='title'>Nuovo protocollo partenza</span>
            </div>
            <div className='protocol-content flex flex-col gap-6'>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmStaticSelect
                        required
                        label="Protocollo"
                        error={departureProtocolState.departureProtocolErrors.headQuarter}
                        errorLabel='Sede mancante'
                        placeholder={'Seleziona protocollo'}
                        options={officeSot}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setPPHeadquarter(newValue))
                        }}
                        disabled={departureProtocolState.fromCreationToUpdate}
                        defaultValue={departureProtocolState.departureProtocolCreationRequest.headQuarter}
                        value={departureProtocolState.departureProtocolCreationRequest.headQuarter}
                        noOptionsMessage={'Nessun protoccolo trovato'}
                    />
                    <Calendar
                        required
                        placeholder='Seleziona data'
                        label="Data protocollo"
                        errorLabel={departureProtocolState.departureProtocolErrors.protocolDate ? 'Data mancante' : undefined}
                        disabled={departureProtocolState.fromCreationToUpdate}
                        selected={departureProtocolState.departureProtocolCreationRequest.protocolDate}
                        onChange={(date) => dispatch(setPProtocolDate(date))}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmStaticSelect
                        label="Nazione"
                        placeholder={'Seleziona nazione'}
                        options={countries}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            !departureProtocolState.fromCreationToUpdate ?
                                dispatch(setPPNation(newValue)) :
                                dispatch(setUpdatePPNation(newValue))
                        }}
                        value={!departureProtocolState.fromCreationToUpdate ?
                            (departureProtocolState.departureProtocolCreationRequest.nation ? departureProtocolState.departureProtocolCreationRequest.nation : 'IT') :
                            (departureProtocolState.departureProtocolCreationRequest.nation ? departureProtocolState.departureProtocolCreationRequest.nation : 'IT')
                        }
                        noOptionsMessage={'Nessuna nazione trovata'}
                    />
                    <MadfarmStaticSelect
                        label="Regione"
                        errorLabel='Regione mancante'
                        placeholder={'Seleziona regione'}
                        options={regioniList}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            !departureProtocolState.fromCreationToUpdate ?
                                dispatch(setPPRegion(newValue)) :
                                dispatch(setUpdatePPRegion(newValue))
                        }}
                        value={!departureProtocolState.fromCreationToUpdate ?
                            (departureProtocolState.departureProtocolCreationRequest.nation ? departureProtocolState.departureProtocolCreationRequest.nation : 'IT') :
                            (departureProtocolState.departureProtocolUpdateRequest.nation ? departureProtocolState.departureProtocolUpdateRequest.nation : 'IT')
                        }
                        noOptionsMessage="Nessuna regione trovata"
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmInput
                        required
                        error={departureProtocolState.departureProtocolErrors.receiver}
                        supportingText={departureProtocolState.departureProtocolErrors.receiver ? 'Mittente mancante' : undefined}
                        label={'Destinatario'}
                        placeholder="Destinatario dei documenti da protocollare"
                        value={!departureProtocolState.fromCreationToUpdate ?
                            departureProtocolState.departureProtocolCreationRequest.receiver :
                            departureProtocolState.departureProtocolUpdateRequest.receiver
                        }
                        onChangeText={(text) => !departureProtocolState.fromCreationToUpdate ?
                            dispatch(setPPReceiver(text)) :
                            dispatch(setUpdatepPSender(text))
                        }
                    />
                    <InputMultiSearch
                        label={'Cliente'}
                        placeholder="Ragione sociale"
                        onSelectAddHandler={(res) => !departureProtocolState.fromCreationToUpdate ?
                            dispatch(setPPCustomerIds(res)) :
                            dispatch(setUpdatePPCustomerIds(res))
                        }
                    />
                </div>
                <div className='grid grid-cols gap-4'>
                    <MadfarmInput
                        label={'Cliente non presente in archivio'}
                        placeholder="Indicare nel caso di cliente non ancora inserito in archivio"
                        value={!departureProtocolState.fromCreationToUpdate ?
                            departureProtocolState.departureProtocolCreationRequest.customersNotRegistered :
                            departureProtocolState.departureProtocolUpdateRequest.customersNotRegistered
                        }
                        onChangeText={(text) => !departureProtocolState.fromCreationToUpdate ?
                            dispatch(setPPCustomersNotRegistered(text)) :
                            dispatch(setUpdatePPCustomersNotRegistered(text))
                        }
                    />
                </div>
                <div className="border h-[1px] border-neutral-200" />
                <div className='flex flex-row items-center gap-4'>
                    <div className={clsx("w-full", { "w-[85%]": userState.findMeResponse.role === "admin" })}>
                        <MadfarmStaticSelect
                            required
                            label="Oggetto (Da elenco)"
                            error={departureProtocolState.departureProtocolErrors.entryObjectId}
                            errorLabel='Oggetto mancante'
                            placeholder={'Seleziona...'}
                            options={objects}
                            value={!departureProtocolState.fromCreationToUpdate ? departureProtocolState.departureProtocolUpdateRequest.departureObjectId : undefined}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value ? value.value : null
                                !departureProtocolState.fromCreationToUpdate ?
                                    dispatch(setPPDepartureObjectId(newValue)) :
                                    dispatch(setUpdatePPDepartureObjectId(newValue))
                            }}
                            noOptionsMessage={'Nessun oggetto trovato'}
                        />
                    </div>
                    {
                        userState.findMeResponse.role === 'admin' &&
                        <div className="w-[15%] pt-5">
                            <ButtonComponent
                                variant='outline'
                                color='orange'
                                size='md'
                                iconPosition='off'
                                label='Crea oggetto'
                                onClick={() => setShowPopup(true)}
                                fullWidth
                            />
                        </div>
                    }
                </div>
                <div className='grid grid-cols'>
                    <TextArea
                        label="Specifiche oggetto"
                        placeholder="Integrazione all'oggetto indicato sopra"
                        onChangeText={(text) => !departureProtocolState.fromCreationToUpdate ?
                            dispatch(setPPObjectSpec(text)) :
                            dispatch(setUpdatePPObjectSpec(text))
                        }
                    />
                </div>
                <div className="border h-[1px] border-neutral-200" />
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmInput
                        // error={entryProtocolState.entryProtocolErrors.totalPage}
                        // supportingText={entryProtocolState.entryProtocolErrors.totalPage ? 'Totale pagine mancante' : undefined}
                        label={'Totale pagine'}
                        placeholder="Specificare numero"
                        value={!departureProtocolState.fromCreationToUpdate ?
                            departureProtocolState.departureProtocolCreationRequest.totalPage?.toString() :
                            departureProtocolState.departureProtocolUpdateRequest.totalPage?.toString()
                        }
                        onChangeText={(text) => !departureProtocolState.fromCreationToUpdate ?
                            dispatch(setPPTotalPage(Number(text))) :
                            dispatch(setUpdatePPTotalPage(Number(text)))
                        }
                    />
                    <MadfarmStaticSelect
                        isClearable
                        noOptionsMessage="Nessun risultato trovato"
                        label="Mezzo entrata"
                        // error={entryProtocolState.entryProtocolErrors.entryChannel}
                        errorLabel='Mezzo mancante'
                        placeholder={'Seleziona...'}
                        options={departureMeansOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            !departureProtocolState.fromCreationToUpdate ?
                                dispatch(setPPDepartureChannel(newValue)) :
                                dispatch(setUpdatePPDepartureChannel(newValue))
                        }}
                        value={!departureProtocolState.fromCreationToUpdate ?
                            departureProtocolState.departureProtocolCreationRequest.departureChannel :
                            departureProtocolState.departureProtocolUpdateRequest.departureChannel
                        }
                    />
                </div>
                <div className="border h-[1px] border-neutral-200" />
                <span className="input-label" style={{ fontSize: '18px', fontWeight: 600 }}>
                    Aggancia a protocollo esistente
                </span>
                <ProtocolSearch
                    type='entry'
                    onSelect={(value) => !departureProtocolState.fromCreationToUpdate ?
                        dispatch(setPPLinkExistingProtocol(value)) :
                        dispatch(setUpdatePPLinkExistingProtocol(value))
                    }
                />
                <div className="border h-[1px] border-neutral-200" />
                <span className="input-label" style={{ fontSize: '18px', fontWeight: 600 }}>
                    Gestione consegna
                </span>
                <div className='grid grid-row-2 gap-4'>
                    <span className="input-label" style={{ fontSize: '16px', fontWeight: 600 }}>
                        Ricevuta a mezzo:
                    </span>
                    <CheckboxGroup
                        name="tipo_consegna_1"
                        options={Object.values(DeliveryManagementType).splice(0, 5)}
                        selectedValues={selectedDeliveries}
                        onChange={handleTypesChange}
                        optionLabels={{
                            [DeliveryManagementType.PEC]: "Posta Elettronica Certificata",
                            [DeliveryManagementType.RACC_AR]: "Raccomandata A/R",
                            [DeliveryManagementType.CORRIERE]: "Corriere",
                            [DeliveryManagementType.RACC_M]: "Raccomandata a mano",
                            [DeliveryManagementType.POST_E]: "Posta elettronica",
                        }}
                    />
                </div>
                {
                    selectedDeliveries.includes(DeliveryManagementType.RACC_AR) && (
                        <>
                            <div className='grid grid-cols-3 gap-4'>
                                <MadfarmInput
                                    // error={}
                                    // supportingText={}
                                    label="Numero raccomandata"
                                    placeholder="Numero raccomandata..."
                                    value={departureProtocolState.departureProtocolCreationRequest.numeroRaccomandata}
                                    defaultValue={departureProtocolState.departureProtocolCreationRequest.numeroRaccomandata}
                                    onChangeText={(text) => {
                                        !departureProtocolState.fromCreationToUpdate ?
                                            dispatch(setNumRaccomandata(text)) :
                                            dispatch(setUpdateNumRaccomandata(text))
                                    }}
                                />
                                <Calendar
                                    label="Data Bolgetta"
                                    selected={departureProtocolState.departureProtocolCreationRequest.dataBolgetta}
                                    onChange={(date) => {
                                        !departureProtocolState.fromCreationToUpdate ?
                                            dispatch(setDataBolgetta(date)) :
                                            dispatch(setUpdateDataBolgetta(date))
                                    }}
                                />
                                <Calendar
                                    label="Data Ricezione Compiuta Giacenza"
                                    selected={departureProtocolState.departureProtocolCreationRequest.dataRicezioneCompiutaGiacenza}
                                    onChange={(date) => {
                                        !departureProtocolState.fromCreationToUpdate ?
                                            dispatch(setDataRicezioneCompiutaGiacenza(date)) :
                                            dispatch(setUpdateDataRicezioneCompiutaGiacenza(date))
                                    }}
                                />
                            </div>
                            <div className='grid grid-cols-2 gap-4'>
                                <Calendar
                                    label="Rispedita per errato indirizzo (Data ritorno)"
                                    selected={departureProtocolState.departureProtocolCreationRequest.dataRitornoErratoIndirizzo}
                                    onChange={(date) => {
                                        !departureProtocolState.fromCreationToUpdate ?
                                            dispatch(setDataRitornoErratoIndirizzo(date)) :
                                            dispatch(setUpdateDataRitornoErratoIndirizzo(date))
                                    }}
                                />
                                <MadfarmInput
                                    label="Raccomandata Errato indirizzo"
                                    placeholder="Numero raccomandata..."
                                    value={departureProtocolState.departureProtocolCreationRequest.numeroRaccomandataErratoIndirizzo}
                                    defaultValue={departureProtocolState.departureProtocolCreationRequest.numeroRaccomandataErratoIndirizzo}
                                    onChangeText={(text) => {
                                        !departureProtocolState.fromCreationToUpdate ?
                                            dispatch(setNumeroRaccomandataErratoIndirizzo(text)) :
                                            dispatch(setUpdateNumeroRaccomandataErratoIndirizzo(text))
                                    }}
                                />
                            </div>
                        </>
                    )}
                <div className="border h-[1px] border-neutral-200" />
                <div className='grid grid-cols-2 gap-4'>
                    <Calendar
                        label="Data ricezione"
                        selected={departureProtocolState.departureProtocolCreationRequest.receive}
                        onChange={(date) => {
                            !departureProtocolState.fromCreationToUpdate ?
                                dispatch(setDataReceive(date)) :
                                dispatch(setUpdateDataReceive(date))
                        }}
                        onClear={() => {
                            !departureProtocolState.fromCreationToUpdate ?
                                dispatch(setDataReceive(undefined)) :
                                dispatch(setUpdateDataReceive(undefined))
                        }}
                    />
                </div>
            </div>
            {
                showPopup && (
                    <PopupForm title='Aggiungi Oggetto' close={() => setShowPopup(false)}>
                        <AddObjectPopupEntry close={() => setShowPopup(false)} />
                    </PopupForm>
                )
            }
        </div>
    )
}